<template>
  <Drawer
    :id="drawerId"
    title="Edit Shipping Address"
  >
    <v-card flat>
      <v-card-text>
        <v-form
          ref="form"
          v-model="valid"
        >
          <v-text-field
            v-model="address.firstName"
            outlined
            label="First Name"
            placeholder="First Name"
            persistent-placeholder
            :rules="[$rules.required]"
            maxlength="100"
            class="white"
          />
          <v-text-field
            v-model="address.lastName"
            outlined
            label="Last Name"
            placeholder="Last Name"
            persistent-placeholder
            :rules="[$rules.required]"
            maxlength="100"
            class="white"
          />
          <v-text-field
            v-model="address.company"
            outlined
            label="Company"
            placeholder="Company"
            persistent-placeholder
            maxlength="100"
            class="white"
          />
          <v-text-field
            v-model="address.line1"
            outlined
            label="Street Address"
            placeholder="Street Address"
            persistent-placeholder
            :rules="[$rules.required]"
            maxlength="100"
            class="white"
          />
          <v-text-field
            v-model="address.line2"
            outlined
            label="Suite, Room, Apt#"
            placeholder="Suite, Room, Apt#"
            persistent-placeholder
            maxlength="100"
            class="white"
          />
          <v-text-field
            v-model="address.city"
            outlined
            label="City"
            placeholder="City"
            persistent-placeholder
            :rules="[$rules.required]"
            maxlength="100"
            class="white"
          />
          <v-select
            v-model="address.countryId"
            outlined
            label="Country"
            placeholder="Country"
            persistent-placeholder
            :items="countriesToShow"
            item-text="name"
            item-value="id"
            :rules="[$rules.required]"
            class="white"
          />
          <v-select
            v-model="address.stateProvinceId"
            outlined
            label="State"
            placeholder="State"
            persistent-placeholder
            :rules="[$rules.required]"
            :items="states(address.countryId)"
            :disabled="states(address.countryId).length == 0"
            item-text="name"
            item-value="id"
            class="white"
          />
          <v-text-field
            v-model="address.postalCode"
            outlined
            label="Zip / Postal Code"
            placeholder="Zip / Postal Code"
            persistent-placeholder
            :rules="[$rules.required]"
            maxlength="5"
            class="white"
          />
        </v-form>
      </v-card-text>
    </v-card>
    <template #append>
      <div class="px-3 py-5">
        <v-btn
          color="primary"
          block
          large
          :loading="saving"
          @click="save"
        >
          Save
        </v-btn>
      </div>
    </template>
  </Drawer>
</template>

<script>
import { mapGetters } from 'vuex';
import { cloneDeep } from 'lodash';
import Drawer from '@/components/layout/Drawer';
import enums from '../../../helpers/enums';
export default {
  name: 'PrintJobEditAddress',
  components: { Drawer },
  data() {
    return {
      valid: false,
      saving: false,
      job: {},
      address: {},
      drawerId: enums.DRAWERS.PRINT_JOB_EDIT_ADDRESS
    };
  },
  computed: {
    countriesToShow() {
      return this.countries.filter((x) => x.isPrintable);
    },
    drawerOpenedAt() {
      return this.$store.state.drawers.lastOpenedAt;
    },
    ...mapGetters({
      countries: 'lookup/countries',
      states: 'lookup/states',
      initialData: 'drawers/data'
    })
  },
  watch: {
    drawerOpenedAt() {
      if (this.drawerId === this.$store.getters['drawers/topDrawer']?.id) {
        this.job = cloneDeep(this.initialData(this.drawerId).job);
        this.address = cloneDeep(this.job.address);
      }
    }
  },
  methods: {
    save() {
      if (!this.$refs.form.validate()) return;
      this.saving = true;
      this.$store
        .dispatch('orders/updateShippingAddress', {
          orderId: this.job.orderId,
          address: this.address
        })
        .then(() => {
          this.$store.commit('drawers/GO_BACK');
        })
        .catch((error) => {
          this.logError(error);
        })
        .finally(() => {
          this.saving = false;
        });
    }
  }
};
</script>
